import GenericApi from '../lib_react_frontend/utils/GenericApi.jsx';

export default (class Api extends GenericApi {

  /**
   * Realiza o login no sistema
   * @param {string} login O usuário.
   * @param {string} senha A Senha.
   */
  static async login(login, senha) {
    return await super.post('/login', { login, senha });
  }

  static async getDadosEmpresaFechamento(cnpj) {
    return await super.get(`/dados_empresa_fechamento?cnpj=${cnpj}`);
  }

  static async getDownloadFechamento(urls) {
    try {
      const response = await super.postConfig(
        '/get_download_fechamento',
        { urls },
        { responseType: 'blob' } // Garante que o Axios trate a resposta como um Blob
      );

      return response.data;
    } catch (error) {
      console.error('Erro no getDownloadFechamento:', error);
      throw error;
    }
  }


  static async getEmpresaUsuario(usuario, filtro) {
    return await super.post('/get_empresa_usuario', { usuario, filtro });
  }
  static async getUsuarios(filtro) {
    return await super.post('/get_usuarios', { filtro });
  }
  static async getEmpresasNaoAdicionadas(empresasAdicionadas) {
    return await super.post('/get_empresas_nao_adicionadas', { empresasAdicionadas });
  }

  static async setAlterarSenha(usuarioId, novaSenha, senhaAtual) {
    return await super.post('/set_nova_senha', { usuarioId, novaSenha, senhaAtual });
  }

  static async recuperarSenha(email) {
    return await super.post('/esqueceu_senha', { email });
  }

  static async trocarSenha(senha, token) {
    return await super.post(`/trocar_senha`, {senha, token});
  }



});



// WEBPACK FOOTER //
// ./src/utils/Api.jsx